/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import Download from '@icon/Download';
import { getImage } from '@utils/imageHelper';
import {
  COURSE_UPDATES_FILE_DOWNLOAD,
  TEST_SERIES_UPDATES_FILE_DOWNLOAD,
  BATCH_UPDATE_FILE_DOWNLOAD,
  TEST_SERIES_KEYS,
  COURSE_KEYS,
  BATCH_KEYS
} from '@constants/segment';
import { evtNameCategoryMap } from '@constants/index';
import { segment } from '@actions/analytics';
import MessageDivider from './MessageDivider';
import Card from './Card';
import AuthorHeader from './AuthorHeader';

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const DocumentName = styled(P2)`
  flex: 1;
  margin: 0px 16px;
  color: var(--color-text-primary);
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
`;

const StyledCard = styled(Card)`
  margin-top: 16px;
`;

const isPGN = (name) => name.substr('-4') === '.pgn';

const getImageName = (name) => (isPGN(name) ? 'pgn.png' : 'pdf.svg');

const onClick = (url, segmentData, isTestSeries, isBatch) => () => {
  let eventName = isTestSeries
    ? TEST_SERIES_UPDATES_FILE_DOWNLOAD
    : COURSE_UPDATES_FILE_DOWNLOAD;
  let eventKeys = isTestSeries ? TEST_SERIES_KEYS : COURSE_KEYS;

  if (isBatch) {
    eventName = BATCH_UPDATE_FILE_DOWNLOAD;
    eventKeys = BATCH_KEYS;
  }

  segment.track(
    eventName,
    segmentData,
    evtNameCategoryMap.WITHOUT_CATEGORY,
    true,
    eventKeys
  );
  window.open(url, '_blank');
};

const DocumentCard = ({ story, batch, segmentData, isTestSeries }) => {
  const { author, object, message, created_at } = story;
  if (!object.url) return null;

  return (
    <>
      <AuthorHeader
        author={author}
        created_at={created_at}
        subtitle={batch && object?.collection?.name}
      />
      <StyledCard>
        <MessageDivider message={message} />
        {object.name && (
          <CardWrapper
            onClick={onClick(object.url, segmentData, isTestSeries, batch)}
          >
            <img
              src={getImage(getImageName(object.name))}
              width="40px"
              alt="Pdf"
            />
            <DocumentName>{object.name}</DocumentName>
            <Download size="24px" color="var(--color-text-primary)" />
          </CardWrapper>
        )}
      </StyledCard>
    </>
  );
};

export default DocumentCard;
